import React from 'react';
import { cn } from '../utils/cn';
const variants = {
  default: 'bg-surface-muted text-fg-secondary',
  success: 'bg-success-100 text-success-700',
  warning: 'bg-warning-100 text-warning-800',
  danger: 'bg-danger-100 text-danger-700',
  info: 'bg-surface-muted text-fg-secondary',
};
const sizes = {
  sm: 'px-1.5 py-0.5 text-xs',
  md: 'px-2 py-0.5 text-sm',
};
export const Badge = React.forwardRef(function Badge(
  { variant = 'default', size = 'sm', dot = false, className, children, ...props },
  ref,
) {
  return (
    <span
      ref={ref}
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-medium',
        variants[variant],
        sizes[size],
        className,
      )}
      {...props}
    >
      {dot && (
        <span
          className={cn(
            'h-1.5 w-1.5 rounded-full',
            variant === 'default' && 'bg-neutral-500',
            variant === 'success' && 'bg-success-500',
            variant === 'warning' && 'bg-warning-500',
            variant === 'danger' && 'bg-danger-500',
            variant === 'info' && 'bg-neutral-500',
          )}
          aria-hidden="true"
        />
      )}
      {children}
    </span>
  );
});
